import React from "react";
import { RaisedButton, TextField } from "material-ui";
import { connect } from "react-redux";
import { commitMutation, graphql } from "react-relay";
import PropTypes from "prop-types";

import environment from "../../relay/environment";

@connect()
class EditTrip extends React.Component {
  static propTypes = {
    handleSave: PropTypes.func.isRequired,
    trip: PropTypes.shape().isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      reason: ""
    };
  }

  close = () => {
    this.props.handleSave();
  };

  save = () => {
    const {
      trip: { id: tripId }
    } = this.props;
    const { reason } = this.state;

    commitMutation(environment, {
      mutation: graphql`
        mutation VoidTrip_CancelTrip_Mutation($input: CancelTripInput!) {
          cancelTrip(input: $input) {
            trip {
              cancelled
              tripName
              welcomeHome
              tasks {
                taskType
                description
                completed
                voided
                history {
                  name
                  action
                  timestamp
                }
              }
            }
          }
        }
      `,
      variables: { input: { tripId, notes: reason } },
      onError: err => alert(err),
      onCompleted: () => this.close()
    });
  };

  updateTextField = fieldName => e => {
    const {
      target: { value }
    } = e;
    const newState = this.state;
    newState[fieldName] = value;
    this.setState(newState);
  };

  render() {
    const { reason } = this.state;
    const hasReason = reason && reason !== "";

    return (
      <div>
        <div style={styles.fieldsGroup}>
          <TextField
            style={styles.formField}
            floatingLabelText="Why is this trip being voided?"
            fullWidth
            value={reason}
            onChange={this.updateTextField("reason")}
          />
        </div>

        <div style={styles.formActions}>
          <RaisedButton
            style={styles.formButton}
            label="Do Not Void Trip"
            primary
            onTouchTap={this.close}
          />
          <RaisedButton
            style={styles.formButton}
            label="Void Trip"
            secondary
            onTouchTap={this.save}
            disabled={!hasReason}
          />
        </div>
      </div>
    );
  }
}

const styles = {
  formActions: {
    display: "flex",
    justifyContent: "flex-end"
  },
  formButton: {
    marginRight: 15
  },
  fieldsGroup: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    flexWrap: "wrap"
  },
  formField: {
    marginRight: 25
  },
  specificDates: {
    marginTop: 15
  }
};

export default EditTrip;



// WEBPACK FOOTER //
// /src/components/Trips/VoidTrip.js